import { render, staticRenderFns } from "./inTotalYouHaveSaved.vue?vue&type=template&id=b3c00c78"
import script from "./inTotalYouHaveSaved.js?vue&type=script&lang=js&external"
export * from "./inTotalYouHaveSaved.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports